import React from 'react';
import { UncontrolledTabs, Tab } from 'components/uncontrolled_tabs';
import Model from 'components/objects/model';
import PropertyList from 'components/property_list';
import { IBusinessPartner } from 'interfaces';
import Translation from 'utils/Language/Translation';
import ProcessingButton from 'components/ProcessingButton';
import { FaCopy } from 'react-icons/fa';
import { sleep } from 'component_utils/utils';
import RoleProtected from 'components/RoleProtected';

interface Props {
  inline?: boolean;
  obj: IBusinessPartner | null;
}

const BusinessPartner = ({ obj, inline }: Props) => {
  const shortDescription = () => <Translation name="T.objects.bp.shortDescription" params={(obj as any) || {}} />;

  const detailedRender = () => {
    return (
      <UncontrolledTabs key={obj!.code}>
        <Tab name={<Translation name="T.misc.information" />}>
          <PropertyList
            rows={[
              [
                <b>
                  <Translation name="T.objects.bp.code" />
                </b>,
                obj!.code,
              ],
              [
                <b>
                  <Translation name="T.objects.bp.visualCode" />
                </b>,
                <>
                  {obj!.visualCode}
                  {' '}
                  <RoleProtected roles={['authCopyObjectCodes']}>
                    <ProcessingButton color="link" className='p-0' onClick={async () => {
                      navigator.clipboard.writeText(obj!.visualCode)
                      await sleep(100)
                    }}>
                      <FaCopy/>
                    </ProcessingButton>
                  </RoleProtected>
                </>,
              ],
              [
                <b>
                  <Translation name="T.objects.bp.name" />
                </b>,
                obj!.name,
              ],
              [
                <b>
                  <Translation name="T.objects.bp.type" />
                </b>,
                obj.type,
              ],
            ]}
          />
        </Tab>
      </UncontrolledTabs>
    );
  };

  const dialog = {
    titleText: <Translation name="T.objects.bp.detailsTitle" />,
    closeBtnText: <Translation name="T.misc.close" />,
    content: () => <BusinessPartner obj={obj} />,
  };
  return (
    <Model
      inline={inline}
      hasLoaded={obj}
      copyValue={() => obj.visualCode}
      description={shortDescription}
      detailedRender={detailedRender}
      dialog={dialog}
    />
  );
};

export default BusinessPartner;
